import { configConstants } from "../constants/action.constants";

const initialState = {
  submitting: false,
  submitted: false,
  request: null,
  response: null,
  error: null
};

export const addConfig = (state = initialState, action) => {
  switch (action.type) {
    case configConstants.ADD_CONFIG_REQUEST:
      return {
        ...state,
        submitting: true,
        submitted: false,
        request: action.requestBody,
        response: null,
        error: null
      };
    case configConstants.ADD_CONFIG_SUCCESS:
      return {
        ...state,
        submitting: false,
        submitted: true,
        response: action.response,
        error: null
      };
    case configConstants.ADD_CONFIG_FAILURE:
      return {
        ...state,
        submitting: false,
        submitted: false,
        response: null,
        error: action.error
      };
    case configConstants.ADD_CONFIG_RESET:
      return {
        ...state,
        ...initialState
      };
    default:
      return state;
  }
};
